import React from 'react';
import AdminConsoleHeader from "../Admin/AdminConsoleHeader";
import OrderAdminList from "../Admin/Order/OrderAdminList";
import OrderAdminSearch from "../Admin/Order/OrderAdminSearch";
import ObjCommonFilterSelection from "../../component/custom/ObjCommonFilterSelection";

const OrderAdmin = () => {

  return (
    <>
      <div className='adminconsole-container orderadmin-container'>
        <AdminConsoleHeader title="ORDER ADMIN" />
        <OrderAdminSearch />
        <ObjCommonFilterSelection />
        <div className="bs5 row mt-2">
        </div>
        <OrderAdminList />
      </div>
    </>
  );
}

export default OrderAdmin;